import {createSelector} from 'reselect';
import props from '../props';

export default createSelector(
    props.app.buttons.claim_cashback,
    (button) => {
        return {
            button
        }
    }
)